import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AgritourismFooterComponent } from '../footer/footer.component';
import { AgritourismHeaderComponent } from '../header/header.component';

@Component({
  selector: 'curbnturf-agritourism-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [AgritourismHeaderComponent, RouterOutlet, AgritourismFooterComponent],
})
export class AgritourismLayoutComponent {}
